export const ActionTypes = {
    SET_GRAPH_DATA: "app/redux/compare-graph/SET_GRAPH_DATA",
    SET_SELECTED_PARAMS: "app/redux/compare-graph/SET_SELECTED_PARAMS",
    SET_GRAPH_RENDERING: "app/redux/compare-graph/SET_GRAPH_RENDERING",
    ADD_SELECTED_PARAMS: "app/redux/compare-graph/ADD_SELECTED_PARAMS",
    DELETE_SELECTED_PARAMS: "app/redux/compare-graph/DELETE_SELECTED_PARAMS",
    SET_LIST_PARAMS: "app/redux/compare-graph/SET_LIST_PARAMS",
    SET_VISIBLE: "app/redux/compare-graph/SET_VISIBLE",
}